export default __webpack_public_path__ + "static/nakahara_img2-3c19596eb3ce1bc5f7c8c71cd87fdd23.jpg";